import WhiteLabel from './WhiteLabel';

export default WhiteLabel;
